import React, { useState } from 'react';
import { DialogContent, DialogOptions, Input } from './styles';
import { Button, Icon } from 'react-materialize';
import { IoMdSave } from 'react-icons/io';
import { FaTrash } from 'react-icons/fa';
import { alerta } from '../../../services/funcoes';

export function DialogEmails({ onClose, onSave, data }) {
  const [currentEmail, setCurrentEmail] = useState('');
  const [emails, setEmails] = useState(data || []);

  return (
    <DialogOptions>
      <DialogContent>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              border: 'none',
              padding: '0.5rem',
              borderRadius: '100%',
              color: '#FFF',
              background: '#8e44ad',
              fontSize: '1.1rem',
              width: '40px',
              height: '40px',
            }}
          >
            X
          </button>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '0.5rem' }}>
          <div style={{ width: '65%' }}>
            <Input
              type="email"
              value={currentEmail}
              id="email"
              name="email"
              autocomplete="off"
              required
              onChange={(ev) => {
                setCurrentEmail(ev.target.value);
              }}
            />
          </div>
          <div style={{ width: '35%' }}>
            <button
              onClick={() => {
                const email = currentEmail;
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                if (!emailRegex.test(email)) {
                  alerta('Por favor, insira um e-mail válido', 2);
                  const emailInput = document.getElementById('email');
                  emailInput.focus();
                } else {
                  setEmails([...emails, currentEmail]);
                  setCurrentEmail('');
                }
              }}
              className="waves-effect waves-light saib-button is-primary"
              style={{
                border: 'none',
                padding: '6px 12px',
                borderRadius: '100px',
                color: '#FFF',
                background: '#8e44ad',
                fontSize: '1rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <Icon>add</Icon> Adicionar email
            </button>
          </div>
        </div>
        <section style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
          <span style={{ fontSize: "1.1rem", fontWeight: "700", borderBottom: "1px solid #c3c3c3", paddingBottom: "0.2rem" }}>Email-s cadastrados</span>
          {emails.map((item) => (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', borderBottom: "1px solid #c3c3c3", paddingBottom: "0.2rem" }}>
              <span style={{ fontSize: '1.2rem', fontWeight: '600' }} key={item}>
                {item}
              </span>
              <button
                style={{
                  border: 'none',
                  padding: '0.5rem',
                  borderRadius: '100%',
                  color: '#FFF',
                  background: 'red',
                  width: '26px',
                  height: '26px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                onClick={() => {
                  const result = emails.filter((e) => e !== item);
                  setEmails(result);
                }}
              >
                <FaTrash size={18} />
              </button>
            </div>
          ))}
        </section>
        <Button
          onClick={() => {
            onSave(emails);
          }}
          className="waves-effect waves-light saib-button is-primary"
        >
          <IoMdSave size={18} style={{ marginRight: '0.4rem' }} /> Salvar
        </Button>
      </DialogContent>
    </DialogOptions>
  );
}
